import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/auth-redirect', '/sso-login', '/m/sample-registration'] // no redirect whitelist

/**
 * 获取cookie值
 * @param {string} name - cookie名称
 * @returns {string|null} cookie值
 */
function getCookie(name) {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop().split(';').shift()
  return null
}

/**
 * 获取系统类型
 * @param {string} path - 路由路径
 * @returns {string} 系统类型
 */
function getSystemType(path) {
  if (path.startsWith('/base') || path.startsWith('/baseInfo') || path.startsWith('/system')) {
    return 'base'
  } else if (path.startsWith('/lab')) {
    return 'lab'
  } else if (path.startsWith('/data')) {
    return 'data'
  } else if (path.startsWith('/oa')) {
    return 'oa'
  } else {
    // return 'oa' // 默认为OA系统

    // 首先尝试从cookie中获取保存的系统类型
    const cookieValue = getCookie('selectedSystem')
    if (cookieValue && ['base', 'lab', 'oa', 'data'].includes(cookieValue)) {
      return cookieValue
    }
    // 如果cookie中没有有效值，默认返回oa系统
    return 'oa'
  }
}

router.beforeEach(async(to, from, next) => {
  // start progress bar
  NProgress.start()

  // 获取系统类型并设置页面标题
  const systemType = getSystemType(to.path)
  document.title = getPageTitle(to.meta.title, systemType)

  // determine whether the user has logged in
  const hasToken = getToken()
  if (hasToken) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({ path: '/' })
      NProgress.done()
    } else {
      // 检查是否已获取用户信息和权限
      const hasUserInfo = store.getters.roles && store.getters.roles.length > 0
      const routesLoaded = store.getters['dynamicRoute/routesLoaded']

      if (hasUserInfo && routesLoaded) {
        // 验证路由权限
        const hasPermission = await store.dispatch('dynamicRoute/hasRoutePermission', to.path)
        if (hasPermission) {
          next()
        } else {
          next({ path: '/401', replace: true })
        }
      } else {
        try {
          // 获取用户信息
          console.log('开始获取用户信息，systemType:', systemType)
          await store.dispatch('user/getInfo', systemType)
          console.log('获取用户信息成功')

          // 生成动态路由
          console.log('开始生成动态路由，systemType:', systemType)
          await store.dispatch('dynamicRoute/generateRoutes', systemType)
          console.log('动态路由生成成功')

          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          next({ ...to, replace: true })
        } catch (error) {
          // remove token and go to login page to re-login
          console.error('获取用户信息或生成路由失败:', error)
          await store.dispatch('user/resetToken')
          await store.dispatch('dynamicRoute/CLEAR_ROUTES')
          Message.error(error.message || '系统错误，请重新登录')
          next('/login')
          NProgress.done()
        }
      }
    }
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
